import classNames from 'classnames';

export const CalendarCheckWithGradient = ({
  className = '',
  color = 'currentColor',
  size = 24,
  ...props
}) => (
  <svg
    className={classNames('icon', className)}
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.625 4.5V4.75H25.875H29.25C29.7804 4.75 30.2891 4.96071 30.6642 5.33579C31.0393 5.71086 31.25 6.21957 31.25 6.75V29.25C31.25 29.7804 31.0393 30.2891 30.6642 30.6642C30.2891 31.0393 29.7804 31.25 29.25 31.25H6.75C6.21957 31.25 5.71086 31.0393 5.33579 30.6642C4.96071 30.2891 4.75 29.7804 4.75 29.25V6.75C4.75 6.21957 4.96071 5.71086 5.33579 5.33579C5.71086 4.96071 6.21957 4.75 6.75 4.75H10.125H10.375V4.5V3.375C10.375 3.14294 10.4672 2.92038 10.6313 2.75628C10.7954 2.59219 11.0179 2.5 11.25 2.5C11.4821 2.5 11.7046 2.59219 11.8687 2.75628C12.0328 2.92038 12.125 3.14294 12.125 3.375V4.5V4.75H12.375H23.625H23.875V4.5V3.375C23.875 3.14294 23.9672 2.92038 24.1313 2.75628C24.2954 2.59219 24.5179 2.5 24.75 2.5C24.9821 2.5 25.2046 2.59219 25.3687 2.75628C25.5328 2.92038 25.625 3.14294 25.625 3.375V4.5ZM16.3125 22.8059L13.9103 20.4023L13.9102 20.4023C13.6522 20.1443 13.3023 19.9994 12.9375 19.9994C12.5727 19.9994 12.2228 20.1443 11.9648 20.4023C11.7068 20.6603 11.5619 21.0102 11.5619 21.375C11.5619 21.7398 11.7068 22.0897 11.9648 22.3477L15.3397 25.7226C15.3397 25.7227 15.3398 25.7227 15.3398 25.7227C15.4675 25.8505 15.6191 25.9519 15.786 26.0211C15.9529 26.0903 16.1318 26.1259 16.3125 26.1259C16.4932 26.1259 16.6721 26.0903 16.839 26.0211C17.0059 25.9519 17.1575 25.8505 17.2852 25.7227C17.2852 25.7227 17.2853 25.7227 17.2853 25.7226L24.0352 18.9727C24.163 18.845 24.2643 18.6933 24.3334 18.5264C24.4025 18.3595 24.4381 18.1807 24.4381 18C24.4381 17.8193 24.4025 17.6405 24.3334 17.4736C24.2643 17.3067 24.163 17.155 24.0352 17.0273L23.8584 17.2041L24.0352 17.0273C23.9075 16.8995 23.7558 16.7982 23.5889 16.7291C23.422 16.66 23.2431 16.6244 23.0625 16.6244C22.8819 16.6244 22.703 16.66 22.5361 16.7291C22.3692 16.7982 22.2175 16.8995 22.0898 17.0273L22.0898 17.0273L16.3125 22.8059ZM6.5 11.25V11.5H6.75H29.25H29.5V11.25V6.75V6.5H29.25H25.875H25.625V6.75V7.875C25.625 8.10706 25.5328 8.32962 25.3687 8.49372C25.2046 8.65781 24.9821 8.75 24.75 8.75C24.5179 8.75 24.2954 8.65781 24.1313 8.49372C23.9672 8.32962 23.875 8.10706 23.875 7.875V6.75V6.5H23.625H12.375H12.125V6.75V7.875C12.125 8.10706 12.0328 8.32962 11.8687 8.49372C11.7046 8.65781 11.4821 8.75 11.25 8.75C11.0179 8.75 10.7954 8.65781 10.6313 8.49372C10.4672 8.32962 10.375 8.10706 10.375 7.875V6.75V6.5H10.125H6.75H6.5V6.75V11.25Z"
      fill="url(#paint0_radial_2717_795)"
      stroke="#2D5FE8"
      strokeWidth="0.5"
    />
    <defs>
      <radialGradient
        id="paint0_radial_2717_795"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20 17) rotate(135) scale(17.6777 16.3179)"
      >
        <stop offset="0.399134" stopColor="#399EFB" />
        <stop offset="1" stopColor="#8BCAFC" />
      </radialGradient>
    </defs>
  </svg>
);
